// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"785":"c6b27596","827":"fb8377c2"}[chunkId] + ".chunk.css";
};